// Tells any open viewer that a document's file was replaced on the server (an
// attorney signature burned in, say), so it reloads the new version instead of
// showing, and later auto-saving over, the old one.

const EVENT_NAME = 'whg:document-replaced';

const preparers = new Set();

// A viewer registers here to finish any save of the document and hold further
// saves before the server replaces it; an upload landing after the replacement
// would put the old file back.
export const registerDocumentReplacePreparer = (prepare) => {
  preparers.add(prepare);
  return () => preparers.delete(prepare);
};

export const prepareDocumentReplace = async (documentId) => {
  if (documentId == null) return;
  const id = String(documentId);
  await Promise.all([...preparers].map((prepare) => Promise.resolve().then(() => prepare(id))));
};

// `replaced: false` releases the hold when the replacement did not happen.
export const announceDocumentReplaced = (documentId, { replaced = true } = {}) => {
  if (documentId == null || typeof window === 'undefined') return;
  window.dispatchEvent(
    new CustomEvent(EVENT_NAME, { detail: { documentId: String(documentId), replaced } })
  );
};

export const subscribeDocumentReplaced = (handler) => {
  if (typeof window === 'undefined') return () => {};
  const listener = (event) => handler(event.detail || {});
  window.addEventListener(EVENT_NAME, listener);
  return () => window.removeEventListener(EVENT_NAME, listener);
};
